import { usePageContent } from "@/hooks/usePageContent";

const useCases = [
  {
    icon: "ri-hospital-line",
    title: "Hospital",
    desc: "Catchment, bed demand and doctor density mapping.",
    image: "https://readdy.ai/api/search-image?query=Modern%20multi%20specialty%20hospital%20building%20exterior%20with%20glass%20and%20white%20facade%2C%20landscaped%20garden%20entrance%20with%20palm%20trees%2C%20clear%20blue%20sky%2C%20professional%20healthcare%20architecture%20photography%2C%20clean%20pristine%20aesthetic%2C%20warm%20natural%20sunlight%2C%20modern%20medical%20facility%20design%2C%20photorealistic%20architectural%20photography&width=640&height=360&seq=usecase-hospital-01&orientation=landscape",
  },
  {
    icon: "ri-graduation-cap-line",
    title: "School",
    desc: "Enrolment potential and land norms per board.",
    image: "https://readdy.ai/api/search-image?query=Modern%20educational%20campus%20building%20with%20contemporary%20architecture%2C%20colorful%20playground%20and%20sports%20field%20in%20foreground%2C%20students%20in%20uniform%20walking%20on%20pathways%2C%20bright%20sunny%20day%20with%20green%20trees%2C%20photorealistic%20campus%20photography%2C%20vibrant%20welcoming%20atmosphere%2C%20clean%20educational%20environment%20design&width=640&height=360&seq=usecase-school-02&orientation=landscape",
  },
  {
    icon: "ri-hotel-line",
    title: "Hotel",
    desc: "ADR, occupancy and brand-tier feasibility.",
    image: "https://readdy.ai/api/search-image?query=Luxury%20hotel%20exterior%20with%20modern%20glass%20architecture%2C%20elegant%20entrance%20with%20portico%20and%20driveway%2C%20palm%20trees%20and%20tropical%20landscaping%2C%20golden%20hour%20sunset%20light%20reflecting%20on%20windows%2C%20photorealistic%20hospitality%20architecture%20photography%2C%20premium%20upscale%20aesthetic%2C%20warm%20inviting%20atmosphere&width=640&height=360&seq=usecase-hotel-03&orientation=landscape",
  },
  {
    icon: "ri-truck-line",
    title: "Warehouse",
    desc: "Freight corridors, 3PL demand and rent bands.",
    image: "https://readdy.ai/api/search-image?query=Modern%20logistics%20warehouse%20facility%20with%20loading%20docks%20and%20trucks%20being%20loaded%2C%20clean%20industrial%20architecture%20with%20steel%20and%20concrete%2C%20efficient%20organized%20operations%2C%20bright%20daylight%20with%20clear%20sky%2C%20photorealistic%20industrial%20photography%2C%20professional%20logistics%20aesthetic%2C%20wide%20angle%20showing%20full%20facility%20scale&width=640&height=360&seq=usecase-warehouse-04&orientation=landscape",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "Retail",
    desc: "Footfall, trade-area spend and anchor mix.",
    image: "https://readdy.ai/api/search-image?query=Modern%20retail%20shopping%20complex%20exterior%20with%20glass%20storefronts%20and%20branded%20signage%2C%20bustling%20pedestrian%20plaza%20with%20shoppers%2C%20contemporary%20architecture%20with%20open%20air%20design%2C%20bright%20sunny%20day%2C%20photorealistic%20commercial%20real%20estate%20photography%2C%20vibrant%20lively%20atmosphere%2C%20clean%20premium%20retail%20aesthetic&width=640&height=360&seq=usecase-retail-05&orientation=landscape",
  },
  {
    icon: "ri-briefcase-line",
    title: "Office",
    desc: "Corridor absorption and Grade-A rent benchmarks.",
    image: "https://readdy.ai/api/search-image?query=Premium%20Grade%20A%20corporate%20office%20tower%20with%20blue%20reflective%20glass%20facade%2C%20modern%20business%20district%20setting%2C%20landscaped%20plaza%20with%20water%20feature%2C%20professional%20workers%20entering%20lobby%2C%20bright%20morning%20light%2C%20photorealistic%20commercial%20architecture%20photography%2C%20clean%20corporate%20aesthetic%2C%20impressive%20towering%20perspective&width=640&height=360&seq=usecase-office-06&orientation=landscape",
  },
  {
    icon: "ri-server-line",
    title: "Data Center",
    desc: "Power, fibre and latency suitability scoring.",
    image: "https://readdy.ai/api/search-image?query=Modern%20data%20center%20facility%20exterior%20with%20industrial%20architecture%2C%20large%20cooling%20units%20and%20power%20infrastructure%20visible%2C%20secure%20fenced%20perimeter%2C%20clean%20technical%20design%2C%20overcast%20sky%20creating%20dramatic%20atmosphere%2C%20photorealistic%20technology%20infrastructure%20photography%2C%20professional%20industrial%20aesthetic%2C%20high%20security%20appearance&width=640&height=360&seq=usecase-datacenter-07&orientation=landscape",
  },
  {
    icon: "ri-charging-pile-2-line",
    title: "EV Charging",
    desc: "Traffic volume, dwell time and grid capacity.",
    image: "https://readdy.ai/api/search-image?query=Modern%20electric%20vehicle%20charging%20station%20with%20sleek%20canopy%20design%2C%20multiple%20EVs%20plugged%20in%20charging%2C%20clean%20contemporary%20architecture%2C%20solar%20panels%20on%20roof%2C%20bright%20sunny%20day%20with%20blue%20sky%2C%20photorealistic%20sustainable%20infrastructure%20photography%2C%20futuristic%20eco%20friendly%20aesthetic%2C%20professional%20commercial%20setting&width=640&height=360&seq=usecase-ev-charging-08&orientation=landscape",
  },
  {
    icon: "ri-parking-box-line",
    title: "Parking",
    desc: "Demand deficit and automated-parking economics.",
    image: "https://readdy.ai/api/search-image?query=Modern%20automated%20multi%20level%20parking%20structure%20with%20sleek%20steel%20and%20glass%20design%2C%20vehicles%20neatly%20parked%20on%20multiple%20levels%2C%20efficient%20urban%20infrastructure%2C%20bright%20daylight%2C%20photorealistic%20urban%20architecture%20photography%2C%20clean%20organized%20aesthetic%2C%20contemporary%20city%20setting%2C%20professional%20infrastructure%20design&width=640&height=360&seq=usecase-parking-09&orientation=landscape",
  },
  {
    icon: "ri-restaurant-2-line",
    title: "Cloud Kitchen",
    desc: "Delivery density and brand-cluster revenue.",
    image: "https://readdy.ai/api/search-image?query=Modern%20cloud%20kitchen%20facility%20interior%20with%20multiple%20cooking%20stations%2C%20stainless%20steel%20equipment%2C%20organized%20delivery%20riders%20picking%20up%20packages%20at%20counter%2C%20clean%20professional%20food%20service%20environment%2C%20bright%20LED%20lighting%2C%20photorealistic%20commercial%20kitchen%20photography%2C%20efficient%20modern%20operation%2C%20warm%20professional%20atmosphere&width=640&height=360&seq=usecase-cloud-kitchen-10&orientation=landscape",
  },
  {
    icon: "ri-group-2-line",
    title: "Co-living",
    desc: "Student and workforce demand, bed-level yields.",
    image: "https://readdy.ai/api/search-image?query=Modern%20co%20living%20residential%20building%20with%20contemporary%20architecture%2C%20communal%20rooftop%20garden%20with%20young%20professionals%20socializing%2C%20warm%20evening%20lighting%2C%20urban%20neighborhood%20setting%2C%20photorealistic%20residential%20architecture%20photography%2C%20vibrant%20community%20atmosphere%2C%20clean%20modern%20design%20with%20green%20elements&width=640&height=360&seq=usecase-coliving-11&orientation=landscape",
  },
  {
    icon: "ri-store-2-line",
    title: "Industrial",
    desc: "Zoning, power load and cluster adjacency.",
    image: "https://readdy.ai/api/search-image?query=Modern%20industrial%20manufacturing%20facility%20with%20clean%20concrete%20and%20steel%20architecture%2C%20large%20roller%20shutters%20and%20loading%20bays%2C%20heavy%20machinery%20visible%20through%20open%20doors%2C%20bright%20daylight%2C%20photorealistic%20industrial%20photography%2C%20professional%20manufacturing%20aesthetic%2C%20organized%20efficient%20operation%2C%20wide%20angle%20showing%20full%20facility&width=640&height=360&seq=usecase-industrial-12&orientation=landscape",
  },
];

export default function UseCasesSection() {
  const { getContent } = usePageContent('homepage');
  const heading = getContent('home-usecases-heading') || '12 Use-Cases Scored for Your Exact Location';

  return (
    <section id="use-cases" className="py-24 bg-background-100">
      <div className="container mx-auto px-4 lg:px-8 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-sm text-primary-500 font-medium uppercase tracking-wider mb-3">
            AI Feasibility Report
          </span>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground-950 mb-4">
            {heading}
          </h2>
          <p className="text-foreground-600">
            We do not guess. Each use-case is ranked on demand, approvals, capex and return using our proprietary AI engine.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {useCases.map((u) => (
            <div
              key={u.title}
              className="flex h-full flex-col rounded-2xl card-dark group hover:border-primary-500/40 transition-all duration-300 overflow-hidden"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={u.image}
                  alt={u.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
              </div>
              <div className="p-5 flex items-start gap-4 flex-1">
                <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-xl bg-primary-500/10">
                  <i className={`${u.icon} text-lg text-primary-500`} />
                </div>
                <div className="min-w-0">
                  <h3 className="font-display font-semibold text-base text-foreground-950">
                    {u.title}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-600 leading-relaxed">
                    {u.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}